<main>
  <header>
    <novus-admin-navbar></novus-admin-navbar>
  </header>
  <section>
    <router-outlet></router-outlet>
  </section>
</main>

